// generated/models/jobRecordStatus.ts
var JobRecordStatus = {
  queued: "queued",
  processing: "processing",
  completed: "completed",
  failed: "failed"
};

export {
  JobRecordStatus
};
//# sourceMappingURL=chunk-UYQUHXRU.mjs.map